import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Carousel } from "./slider";
import { GamesCarousel } from "./GamesCarousel";
import SearchField from "../common/SearchField";

import {
  openLoginModal,
  openPaymentModal,
} from "../../features/slices/ModalSlice";
import {
  hideChatBox,
  updateSelectedItem,
} from "../../features/slices/CommonSlice";
import {
  getFavGames,
  getLastPlayedGames,
  relogin,
} from "../../features/slices/UserSlice";
import { fetchCategories } from "../../features/slices/GamesSlice";
import casinoCardImg from "../../assets/images/gamescard/casino-card.png";
import gamesSlotsCardImg from "../../assets/images/gamescard/games-slots-card.png";
import sportsCardImg from "../../assets/images/gamescard/sports-card.png";
import matkaCardImg from "../../assets/images/gamescard/matka-card.png";
import { hasLoggedInBefore } from "../../utils/rememberMe";

export function Home() {
  const dispatch = useDispatch();
  const game = useSelector((state) => state.game);
  const user = useSelector((state) => state.user);
  const [showUsernameSetup, setShowUsernameSetup] = useState(true);
  useEffect(() => {
    dispatch(fetchCategories());
  }, []);

  const userFavs = user.favGames;
  const lastPlayedByUser = user.lastPlayedGames;
  // brand-new visitors never see these lists; they appear after the first login
  const showGameLists = user.userLoggedIn || hasLoggedInBefore();

  useEffect(() => {
    if (user.userLoggedIn) {
      dispatch(getFavGames());
      dispatch(getLastPlayedGames());
    }
  }, [user.userLoggedIn]);

  useEffect(() => {
    if (localStorage.getItem("moveToFavourite")) {
      const section = document.getElementById("favGames");
      section?.scrollIntoView({ behavior: "smooth" });
    }

    setTimeout(() => {
      localStorage.removeItem("moveToFavourite");
    }, 200);
    if (localStorage.getItem("openDeposit"))
      setTimeout(() => {
        dispatch(openPaymentModal("Deposit"));
        dispatch(updateSelectedItem("deposit"));
        localStorage.removeItem("openDeposit");
      }, 1000);
  }, []);

  const getCategoryId = (keywords, fallbackId) => {
    if (!game.categories?.length) return fallbackId;
    const found = game.categories.find((cat) =>
      keywords.some((kw) => cat.name?.toLowerCase().includes(kw.toLowerCase()))
    );
    return found ? found.id : fallbackId;
  };

  const openLoginPopup = () => {
    dispatch(openLoginModal("login"));
    dispatch(relogin());
    dispatch(hideChatBox());
  };

  const featuredCards = [
    {
      id: "casino",
      title: "CASINO",
      image: casinoCardImg,
      link: `/all-games?category=${getCategoryId(["live casino", "casino"], "3")}`,
    },
    {
      id: "games-slots",
      title: "GAMES & SLOTS",
      image: gamesSlotsCardImg,
      link: `/all-games?category=${getCategoryId(["slot", "crash", "mini"], "4")}`,
    },
    {
      id: "sports",
      title: "SPORTS",
      image: sportsCardImg,
      // same as the navbar Sports item: launches the sportsbook, login mandatory
      link: "/sports",
      requiresLogin: true,
    },
    {
      id: "makta",
      title: "MATKA",
      image: matkaCardImg,
      link: "/matka",
    },
  ];

  return (
    <div>
      {showUsernameSetup && (
        <popup onClose={() => setShowUsernameSetup(false)} />
      )}
      <Carousel />
      <SearchField isHome={true} />
      <div className="container-fluid games-section custom-padding">
        <div className="game-category-grid">
          {featuredCards.map((card) => (
            <a
              key={card.id}
              href={
                card.requiresLogin && !user.userLoggedIn
                  ? undefined
                  : card.link
              }
              onClick={
                card.requiresLogin && !user.userLoggedIn
                  ? openLoginPopup
                  : undefined
              }
              className="game-category-card"
              aria-label={card.title}
            >
              <div className="game-category-card-inner">
                <img
                  loading="lazy"
                  src={card.image}
                  alt={card.title}
                  className="game-category-img"
                />
              </div>
            </a>
          ))}
        </div>
      </div>
      {/* logged-out visitors see the lists saved in this browser */}
      {showGameLists && (
        <div
          className="container-fluid custom-padding games-carousel"
          id="favGames"
        >
          <div className="home-game-section">
            <h4 className="pb-3">Last Played Games</h4>
            {lastPlayedByUser.length ? (
              <div className="mb-4">
                <GamesCarousel fav={false} data={lastPlayedByUser} />
              </div>
            ) : (
              <p className="home-game-empty">
                Games you play will show up here.
              </p>
            )}
          </div>
          <div className="home-game-section mt-5">
            <h4 className="pb-3">Your Favourite</h4>
            {userFavs.length ? (
              <div className="mb-4">
                <GamesCarousel fav={true} data={userFavs} />
              </div>
            ) : (
              <p className="home-game-empty">
                Tap the star on a game to add it to your favourites.
              </p>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
